import type { OrderProductResponse, PaymentPositionResponse } from '@/core/generated/api';
import { calculatePaymentPositionTotals, paymentPositionsToView } from '../mappers';
import { RequestEmpty } from '@/shared/ui/RequestState';
import { Link } from '@/shared/ui/Link/Link';
import classes from './PaymentPositionsTable.module.scss';
import { Fragment } from 'react';

interface PaymentPositionsTableProps {
    positions: PaymentPositionResponse[];
    orderProducts: OrderProductResponse[];
}

/** Показывает денежное значение позиции платежа */
const formatPrice = (value: number | null) => value == null
    ? '—'
    : value.toFixed(2);

/** Показывает позиции платежа, их скидки и общие итоги */
export const PaymentPositionsTable = ({ positions, orderProducts }: PaymentPositionsTableProps) => {
    if (positions.length === 0) {
        return <RequestEmpty message="Нет позиций платежа" />;
    }

    const rows = paymentPositionsToView(positions, orderProducts);
    const totals = calculatePaymentPositionTotals(positions);

    return (
        <div className={classes.scrollable}>
            <table className={classes.table}>
                <thead>
                    <tr>
                        <th scope="col">Товар</th>
                        <th scope="col">Количество</th>
                        <th scope="col">Сумма без скидки</th>
                        <th scope="col">Скидка</th>
                        <th scope="col">Итого</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row) => (
                        <Fragment key={row.key}>
                            <tr>
                                <td>{row.productUrl
                                    ? <Link
                                        text={row.productName}
                                        url={row.productUrl}
                                        isBlank
                                    />
                                    : row.productName}</td>
                                <td>{row.quantity ?? '—'}</td>
                                <td>{formatPrice(row.amount)}</td>
                                <td>{formatPrice(row.discount)}</td>
                                <td>{formatPrice(row.amountWithDiscount)}</td>
                            </tr>
                            {row.discounts.map((discount, discountIndex) => (
                                <tr
                                    key={discountIndex}
                                    className={classes.discountRow}
                                >
                                    <td>• {discount.name}</td>
                                    <td />
                                    <td />
                                    <td>{formatPrice(discount.amount)}</td>
                                    <td />
                                </tr>
                            ))}
                        </Fragment>
                    ))}
                    <tr className={classes.totalRow}>
                        <th scope="row">Итого</th>
                        <td>{totals.quantity ?? '—'}</td>
                        <td>{formatPrice(totals.amount)}</td>
                        <td>{formatPrice(totals.discount)}</td>
                        <td>{formatPrice(totals.amountWithDiscount)}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
